import { useEffect, useState, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ConsultationModal from "@/components/ConsultationModal";
import GATracker from "@/components/GATracker";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import PackagePage from "@/pages/PackagePage";
import Audit from "@/pages/Audit";
import CaseStudies from "@/pages/CaseStudies";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import ArticlePage from "@/pages/ArticlePage";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReportPage from "@/pages/AdminReportPage";

const ConsultContext = createContext({ consultOpen: false, openConsult: () => {}, closeConsult: () => {} });
export const useConsult = () => useContext(ConsultContext);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [consultOpen, setConsultOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <ConsultContext.Provider
        value={{ consultOpen, openConsult: () => setConsultOpen(true), closeConsult: () => setConsultOpen(false) }}
      >
        <BrowserRouter>
          <ScrollToTop />
          <GATracker />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:packageId" element={<PackagePage />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<ArticlePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/reports/:reportId" element={<AdminReportPage />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
          <CookieConsent />
          <ConsultationModal />
          <Toaster position="top-center" theme="dark" />
        </BrowserRouter>
      </ConsultContext.Provider>
    </div>
  );
}

export default App;
